import React from 'react';
import { DealerCustomersListView } from './component';
import { ICustomerItem } from '../Models';

interface IDealerListViewContainer {
  setSelectedCustomer: (customer: ICustomerItem) => void;
  selectedCustomer?: ICustomerItem;
  customerData: ICustomerItem[];
  hideColumns?: { [key: string]: boolean };
}

export const DealerCustomersListContainer = ({
  setSelectedCustomer,
  selectedCustomer,
  customerData,
  hideColumns,
}: IDealerListViewContainer) => {
  const handleOnSelect = async (row: any) => {
    const item = row as ICustomerItem;
    setSelectedCustomer(item);
  };

  return (
    <>
      <DealerCustomersListView
        customerData={customerData}
        selectedCustomer={selectedCustomer}
        handleOnSelect={handleOnSelect}
        hideColumns={hideColumns}
      />
    </>
  );
};

DealerCustomersListContainer.defaultProps = {
  selectedCustomer: undefined,
  hideColumns: {},
};
